module.exports = __webpack_public_path__ + "img/aavatar.fa45c22b.png";